import { render, staticRenderFns } from "./index-tc.vue?vue&type=template&id=0dcb5bc4&scoped=true"
import script from "./index-tc.vue?vue&type=script&lang=js"
export * from "./index-tc.vue?vue&type=script&lang=js"
import style0 from "./index-tc.vue?vue&type=style&index=0&id=0dcb5bc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcb5bc4",
  null
  
)

export default component.exports